import { render, staticRenderFns } from "./ModalDetalheTarefasComponent.vue?vue&type=template&id=40d6379c"
import script from "./ModalDetalheTarefasComponent.vue?vue&type=script&lang=js"
export * from "./ModalDetalheTarefasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports